import { apiRequest } from "../../services/apiService";
import { ADD_QUESTION_FAIL, ADD_QUESTION_REQUEST, ADD_QUESTION_SUCCESS, ADD_SECTION_FAIL, ADD_SECTION_REQUEST, ADD_SECTION_SUCCESS, DELETE_QUESTION_FAIL, DELETE_QUESTION_REQUEST, DELETE_QUESTION_SUCCESS, DELETE_SECTION_FAIL, DELETE_SECTION_MERGE_QUESTION_FAIL, DELETE_SECTION_MERGE_QUESTION_REQUEST, DELETE_SECTION_MERGE_QUESTION_SUCCESS, DELETE_SECTION_REQUEST, DELETE_SECTION_SUCCESS, DUPLICATE_QUESTION_FAIL, DUPLICATE_QUESTION_REQUEST, DUPLICATE_QUESTION_SUCCESS, DUPLICATE_SECTION_FAIL, DUPLICATE_SECTION_REQUEST, DUPLICATE_SECTION_SUCCESS, GET_SURVEY_DATA_FAIL, GET_SURVEY_DATA_REQUEST, GET_SURVEY_DATA_SUCCESS, GET_SURVEY_QUESTION_DATA_FAIL, GET_SURVEY_QUESTION_DATA_REQUEST, GET_SURVEY_QUESTION_DATA_SUCCESS, GET_SURVEY_SECTION_DATA_FAIL, GET_SURVEY_SECTION_DATA_REQUEST, GET_SURVEY_SECTION_DATA_SUCCESS, SET_SURVEY_DES, SET_SURVEY_NAME, SET_SURVEY_TITLE, UPDATE_OPTIONS_FAIL, UPDATE_OPTIONS_REQUEST, UPDATE_OPTIONS_SUCCESS, UPDATE_QUESTION_CONTROL_FAIL, UPDATE_QUESTION_CONTROL_REQUEST, UPDATE_QUESTION_CONTROL_SUCCESS, UPDATE_QUESTION_FAIL, UPDATE_QUESTION_HINT_FAIL, UPDATE_QUESTION_HINT_REQUEST, UPDATE_QUESTION_HINT_SUCCESS, UPDATE_QUESTION_ORDERING_FAIL, UPDATE_QUESTION_ORDERING_REQUEST, UPDATE_QUESTION_ORDERING_SUCCESS, UPDATE_QUESTION_REQUEST, UPDATE_QUESTION_SUCCESS, UPDATE_QUESTION_TEXT_FAIL, UPDATE_QUESTION_TEXT_REQUEST, UPDATE_QUESTION_TEXT_SUCCESS, UPDATE_QUESTION_TYPE_FAIL, UPDATE_QUESTION_TYPE_REQUEST, UPDATE_QUESTION_TYPE_SUCCESS, UPDATE_SCORE_FAIL, UPDATE_SCORE_REQUEST, UPDATE_SCORE_SUCCESS, UPDATE_SECTION_DESC_FAIL, UPDATE_SECTION_DESC_REQUEST, UPDATE_SECTION_DESC_SUCCESS, UPDATE_SECTION_ORDERING_FAIL, UPDATE_SECTION_ORDERING_REQUEST, UPDATE_SECTION_ORDERING_SUCCESS, UPDATE_SECTION_TITLE_FAIL, UPDATE_SECTION_TITLE_REQUEST, UPDATE_SECTION_TITLE_SUCCESS } from "../constant";

//Save survey details (Title, Description)
export const saveSurveyTitle = (data) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSurveyTitle`,
            data: data
        })
        if (response) {
            dispatch({ type: SET_SURVEY_TITLE, payload: data.val })
            dispatch({ type: SET_SURVEY_NAME, payload: data.val })

        }
        else if (error) {
            console.log('error in saving survey title', error)
        }
    }
}

export const saveSurveyDes = (data) => {
    return async (dispatch) => {
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSurveyDesc`,
            data: data
        })
        if (response) {
            dispatch({ type: SET_SURVEY_DES, payload: data.val })
        }
        else if (error) {
            console.log('error in saving survey description', error)
        }
    }
}


//Get survey data
export const getSurveyData = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getSurveyDetail?survey_id=${survey_id}`,
        })
        if (response) {
            dispatch({ type: GET_SURVEY_DATA_SUCCESS, payload: response?.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_SURVEY_DATA_FAIL })
        }
    }
}

export const getSurveySectionData = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_SECTION_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getSection?survey_id=${survey_id}`,
        })
        if (response) {
            dispatch({ type: GET_SURVEY_SECTION_DATA_SUCCESS, payload: response?.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_SURVEY_SECTION_DATA_FAIL })
        }
    }
}

export const getSurveyQuestionData = (survey_id) => {
    return async (dispatch) => {
        dispatch({ type: GET_SURVEY_QUESTION_DATA_REQUEST });
        const { response, error } = await apiRequest({
            method: 'GET',
            url: `/survey/getQuesBySurvey?survey_id=${survey_id}`,
        })
        if (response) {
            dispatch({ type: GET_SURVEY_QUESTION_DATA_SUCCESS, payload: response?.data?.data })
        }
        else if (error) {
            dispatch({ type: GET_SURVEY_QUESTION_DATA_FAIL })
        }
    }
}


//Section add, delete, duplicate, ordering(sorting)
export const addSection = (data) => {
    return async (dispatch) => {
        dispatch({ type: ADD_SECTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/crtSection`,
            data: data
        })
        if (response) {
            dispatch(getSurveySectionData(data?.su_survey_id))
            dispatch({ type: ADD_SECTION_SUCCESS, payload: { ...data, id: response?.data?.data?.insertId ?? null } })
        }
        else if (error) {
            dispatch({ type: ADD_SECTION_FAIL })
        }
    }
}

export const deleteSection = (data) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_SECTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delSection`,
            data: data
        })
        if (response) {
            dispatch({ type: DELETE_SECTION_SUCCESS, payload: data?.section_id })
        }
        else if (error) {
            dispatch({ type: DELETE_SECTION_FAIL })
        }
    }
}

export const deleteAndMergeSection = (data) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_SECTION_MERGE_QUESTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delSecAndMergeQue`,
            data: data
        })
        if (response) {
            dispatch({ type: DELETE_SECTION_MERGE_QUESTION_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: DELETE_SECTION_MERGE_QUESTION_FAIL })
        }
    }
}

export const duplicateSection = (data, successCallback = () => { }) => {
    return async (dispatch) => {
        dispatch({ type: DUPLICATE_SECTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/duplicateSection`,
            data: data
        })
        if (response) {
            successCallback()
            dispatch({ type: DUPLICATE_SECTION_SUCCESS, payload: { ...response?.data?.data, old_section_id: data?.section_id } })
        }
        else if (error) {
            dispatch({ type: DUPLICATE_SECTION_FAIL })
        }
    }
}

export const orderSection = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SECTION_ORDERING_REQUEST })
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSectionOrdering`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_SECTION_ORDERING_SUCCESS, payload: data.section_order })
        }
        else if (error) {
            dispatch({ type: UPDATE_SECTION_ORDERING_FAIL })
        }
    }
}


//Question add, delete, duplicate, ordering(sorting)
export const deleteQuestion = (data) => {
    return async (dispatch) => {
        dispatch({ type: DELETE_QUESTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'DELETE',
            url: `/survey/delQues`,
            data: data
        })
        if (response) {
            dispatch({ type: DELETE_QUESTION_SUCCESS, payload: data?.qid })
        }
        else if (error) {
            dispatch({ type: DELETE_QUESTION_FAIL })
        }
    }
}

export const addQuestion = (data) => {
    return async (dispatch) => {
        dispatch({ type: ADD_QUESTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/addQues`,
            data: data
        })
        if (response) {
            dispatch(getSurveyQuestionData(data.survey_id))
            dispatch({ type: ADD_QUESTION_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: ADD_QUESTION_FAIL })
        }
    }
}

export const duplicateQuestion = (data) => {
    return async (dispatch) => {
        dispatch({ type: DUPLICATE_QUESTION_REQUEST })
        const { response, error } = await apiRequest({
            method: 'POST',
            url: `/survey/duplicateQues`,
            data: data
        })
        if (response) {
            console.log('response', response.data.data)
            dispatch({ type: DUPLICATE_QUESTION_SUCCESS, payload: { question_id: data.question_id, new_question_id: response?.data?.data?.insertId } })
        }
        else if (error) {
            dispatch({ type: DUPLICATE_QUESTION_FAIL })
        }
    }
}

export const orderQuestion = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_QUESTION_ORDERING_REQUEST })
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updQuestionOrdering`,
            data: data
        })
        if (response) {
            successCallback()
            dispatch({ type: UPDATE_QUESTION_ORDERING_SUCCESS, payload: data.question_order })
        }
        else if (error) {
            dispatch({ type: UPDATE_QUESTION_ORDERING_FAIL })
        }
    }
}


//Save section details (Title, Description)
export const saveSectionTitle = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SECTION_TITLE_REQUEST })
        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSectionTitle`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_SECTION_TITLE_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_SECTION_TITLE_FAIL })
        }
    }
}

export const saveSectionDesc = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_SECTION_DESC_REQUEST })

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updSectionDesc`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_SECTION_DESC_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_SECTION_DESC_FAIL })
        }
    }
}


//Multiple choice question options handling
export const updateQuestion = (data, successCallback) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_QUESTION_REQUEST })

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updQues`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_QUESTION_SUCCESS, payload: data })
            successCallback()
        }
        else if (error) {
            dispatch({ type: UPDATE_QUESTION_FAIL })
        }
    }
}


//Question type and other ctrl
export const updateQuestionType = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_QUESTION_TYPE_REQUEST })

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updQuesType`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_QUESTION_TYPE_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_QUESTION_TYPE_FAIL })
        }
    }
}

export const updateQuestionControl = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_QUESTION_CONTROL_REQUEST })

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updQuesControl`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_QUESTION_CONTROL_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_QUESTION_CONTROL_FAIL })
        }
    }
}

export const updateQuestionText = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_QUESTION_TEXT_REQUEST })

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updQuesText`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_QUESTION_TEXT_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_QUESTION_TEXT_FAIL })
        }
    }
}

export const updateQuestionHint = (data) => {
    return async (dispatch) => {
        dispatch({ type: UPDATE_QUESTION_HINT_REQUEST })

        const { response, error } = await apiRequest({
            method: 'PATCH',
            url: `/survey/updQuesHint`,
            data: data
        })
        if (response) {
            dispatch({ type: UPDATE_QUESTION_HINT_SUCCESS, payload: data })
        }
        else if (error) {
            dispatch({ type: UPDATE_QUESTION_HINT_FAIL })
        }
    }
}